module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0142.jpg?v=d18173a3";